export const LEADS_PAGE_SIZE = 10
export const BUILDINGS_PAGE_SIZE = 10
